import { Illustration, Stack, Text } from "@certn/cascadia-react";
import { CascadiaIllustration } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { ReactNode, useEffect, useId } from "react";

interface Props {
  illustration?: CascadiaIllustration;
  title: string;
  subtitle?: string | ReactNode;
  actions?: ReactNode;
  focusTitle?: boolean;
}

export function EmptyState(props: Props) {
  const { illustration, title, subtitle, actions, focusTitle } = props;
  const titleId = useId();

  useEffect(() => {
    if (focusTitle) {
      document.getElementById(titleId)?.focus();
    }
  }, [focusTitle, titleId]);

  return (
    <Stack gap="space-4" align="center" className={styles.container}>
      <Stack gap="space-4" align="center">
        {illustration && <Illustration name={illustration} />}
        <Text
          id={titleId}
          as="h1"
          style="global/heading-medium"
          align="center"
          tabIndex={focusTitle ? -1 : undefined}
        >
          {title}
        </Text>
        {subtitle && (
          <Text style="form/body-secondary" align="center" color="text-weak">
            {subtitle}
          </Text>
        )}
        {actions}
      </Stack>
    </Stack>
  );
}

const styles = {
  container: css({
    padding: "var(--space-10) var(--space-4)",
  }),
};
